<template>
  <section class="preview">
    <form class="form" novalidate @submit.prevent="crear">
      <!-- Styled -->
      <mdb-input
        placeholder="Codigo pixel"
        class="mb-3 mt-0"
        v-model="pixel_code"
        required
        invalidFeedback="Coloca el codigo"
      >
        <span class="input-group-text md-addon" slot="prepend">Nombre</span>
      </mdb-input>

      <div class="form-group">
        <label class="typo__label">Cuentas ads</label>
        <multiselect
          v-model="adsSelected"
          placeholder="Seleccione cuentas"
          label="name"
          track-by="id"
          :options="ads"
          :close-on-select="false"
          :clear-on-select="false"
          :multiple="true"
          :taggable="true"
        ></multiselect>
      </div>

      <div class="text-center">
        <mdb-btn type="submit" color="primary" :disabled="isLoading">
          <span v-if="!isLoading">Crear</span>
          <semipolar-spinner :animation-duration="2000" :size="30" color="#ffffff" v-if="isLoading"></semipolar-spinner>
        </mdb-btn>
      </div>
    </form>
  </section>
</template>

<script>
import Multiselect from "vue-multiselect";
import { mdbInput, mdbBtn } from "mdbvue";
import { SemipolarSpinner } from "epic-spinners";
import store from "../../store";
export default {
  name: "modal-1",
  components: {
    mdbInput,
    mdbBtn,
    SemipolarSpinner,
    Multiselect
  },
  props: {
    onClick: Function
  },
  data: () => {
    return {
      isLoading: false,
      pixel_code: "",
      ads: [],
      adsSelected: []
    };
  },
  async mounted() {
    var respuesta = await this.getAccounts();
  },
  methods: {
    async getAccounts() {
      var ads = store.getters.getAdsAccounts;

      if (ads.length == 0) {
        this.isLoading = true;
        store.dispatch("getAdsAccounts").then(() => {
          ads = store.getters.getAdsAccounts;
          this.ads = ads;
          this.isLoading = false;
        });
      } else {
        this.ads = ads;
      }
    },
    crear(event) {
      event.target.classList.add("was-validated");
      var { pixel_code, adsSelected } = this;
      this.isLoading = true;
      if (pixel_code == "" || adsSelected.length == 0) {
        this.isLoading = false;
      } else {
        var account_ids = [];
        adsSelected.map(i => {
          account_ids.push(i.id);
        });
        var partner = {
          account_ids,
          pixel_code
        };
        store.dispatch("newPixel", partner).then(() => {
          /*this.name = "";
          this.website = "";
          this.email = "";
          this.street = "";
          this.phone = "";
          this.mobile = "";
          this.fax = "";
          this.selectedCountry = {};
          this.accountsSelected = [];
          this.pagesSelected = [];*/
          this.onClick();
          this.isLoading = false;
        });
      }
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.prueba-circulo {
  background-image: url("");
  background-repeat: no-repeat;
  width: 200px;
  height: 200px;
  background: #cccccc;
  border-radius: 100%;
  position: relative;
}
.form {
  position: relative;
  bottom: 80px;
}
</style>